import CustomActionsPaneSummary from './CustomActionsPaneSummary';

export default CustomActionsPaneSummary;
export { CustomActionsPaneSummary };
